/** All how-to guides, merged. Edit the area files to change wording. */
import { BASICS, EXEC_GUIDES } from './guides.exec';
import { FRONT_GUIDES } from './guides.front';
import { OPS_GUIDES } from './guides.ops';
import { FINANCE_GUIDES } from './guides.finance';

export { BASICS };
export const GUIDES = { ...EXEC_GUIDES, ...FRONT_GUIDES, ...OPS_GUIDES, ...FINANCE_GUIDES };

/* Shown under every guide's own questions */
export const COMMON_FAQ = [
  { q: 'A button or tab mentioned here is missing', a: 'Your role may not include that feature. Ask the admin to check your role in Staff Accounts.' },
  { q: 'The screen is blank or shows an error', a: 'Reload the page once. If it continues, note the exact message and what you clicked, and tell the admin.' },
  { q: 'I was logged out suddenly', a: 'Your session expired, someone logged in with your account elsewhere (single session), or it is outside the allowed login hours. Log in again or ask the admin.' },
];
